import classNames from 'classnames'
import React from 'react'

export default function Icon({
    icon,
    large,
    color
}) {

    const Classes = classNames({
        [`icon icon-${icon}`]: true,
        "text-2xl": !large,
        [`text-${color}`]: color,
    })

    return (
        <i className={Classes}></i>
    )
}